export default __webpack_public_path__ + "static/media/mobile-menu.dc6deca1.svg";